import ConfigETC from "../Class/ConfigETC.json";
import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { PdfTrueTypeFont } from "@syncfusion/ej2-pdf-export";
import { adventProFont } from "../Class/font.jsx";
import Pathurl from "../Class/Pathurl.json";

import { L10n } from '@syncfusion/ej2-base';

const Swal = require("sweetalert2");

// Edit By POOM : 2023-11-03
//   ปรับจาก ขึ้น MSG บอก Time Out เปลี่ยนเป็น ยิงไปยังหน้า timeout ก่อน แล้วค่อยขึ้น msg เพื่อ กลับไปหน้า login
//  ที่ต้องปรับ  เพราะ  บางหน้า พอขึ้น msg timeout แล้ว  แต่ ตัว divLoadingProgress ยังหมุนอยู่ 
//                 เลยทำให้  ไม่สามารถกด ok ของ msg ได้ หน้าเลยค้าง

/* Update By Krisana : 07-05-2024 - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer */

export const Class_ETC_SessionTimeOut = () => {
  window.location.replace("../" + Pathurl.timeout);
  /*
  Swal.fire({
    position: "center",
    icon: "error",
    title: "Error!",
    text: " Session Time Out",
    showConfirmButton: true,
    didClose: () => {
      Class_ETC_Logout();
    },
  });
  */
};

export const Class_ETC_MsgSessionTimeOut = () => {
  Swal.fire({
    position: "center",
    icon: "error",
    title: "Error!",
    text: " Session Time Out",
    showConfirmButton: true,
    didClose: () => {
      Class_ETC_Logout();
    },
  });
};

export const Class_ETC_Logout = () => {
  window.location.replace("../login");
};

export const Class_ETC_MsgError = (msg, nextfunction) => {
  Swal.fire({
    position: "center",
    icon: "error",
    title: "Error!",
    text: msg,
    showConfirmButton: true,
    didClose: () => {
      if (nextfunction !== null) {
        nextfunction();
      }
    },
  });
};
export const Class_ETC_MsgErrorfocusByID = (msg, id) => {
  Swal.fire({
    position: "center",
    icon: "error",
    title: "Error!",
    text: msg,
    showConfirmButton: true,
    didClose: () => {
      focusByID(id);
    },
  });
};

export const focusByID = (id) => {
  try {
    document.getElementById(id).focus();
  } catch {}
};

export const Class_ETC_MsgSuccess = (msg, nextfunction) => {
  Swal.fire({
    position: "center",
    icon: "success",
    title: "success!",
    text: msg,
    showConfirmButton: true,
    didClose: () => {
      if (nextfunction !== null) {
        nextfunction();
      }
    },
  });
};

export const Class_ETC_Warning = (msg, nextfunction) => {
  Swal.fire({
    icon: "warning",
    title: "Warning!",
    text: msg,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
    showCancelButton: true,
  }).then((result) => {
    if (result.isConfirmed) {
      nextfunction();
    }
  });
};

//Add by POOM : 2023-07-05 ให้มีการ ทำ function ทั้งกด yes or no
//  เจอว่า ไม่ว่าจะกด yes หรือ no  function นี้ จะทำงาน 2 รอบ คือ 1 .เข้า yes or no  2. no  ที่อยู่ใน did
//  function นี้ ใช้สำหรับ การปิดหรือ no function ใช้แบบเดียวกันได้
export const Class_ETC_Warning_actionYesandNo = (
  msg,
  yesfunction,
  nofunction
) => {
  Swal.fire({
    icon: "warning",
    title: "Warning!",
    text: msg,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
    showCancelButton: true,
    didClose: () => {
      if (nofunction !== null) {
        // ถ้า กดปิด pop up ให้ทำ nofunction
        nofunction();
      }
    },
  }).then((result) => {
    if (result.isConfirmed) {
      yesfunction();
    } else {
      nofunction();
    }
  });
};

//Add by PRATAN : 2024-04-24 ให้มีการ ทำ function ทั้งกด yes or no
// เมื่อเลือกกด yes หรือ no  function นี้ จะทำงานเพียงแค่เข้า yes or no เท่านั้น
// หากว่ากดปิด pop up ไปเลย function จะเข้าทำงานที่ no เสมอ
export const Class_ETC_Warning_actionYesandNo_NodidClose = (
  msg,
  yesfunction,
  nofunction
) => {
  Swal.fire({
    icon: "info",
    title: "Information",
    text: msg,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    showCancelButton: true,
    allowOutsideClick: false, // false = ไม่อนุญาตให้คลิกที่พิ้นหลังได้
    allowEscapeKey: false, // false = ไม่อนุญาตให้กด esc ได้
  }).then((result) => {
    if (result.isConfirmed) {
      yesfunction();
    } else {
      nofunction();
    }
  });
};


export const Class_ETC_MsgWarning = (msg, nextfunction) => {
  Swal.fire({
    position: "center",
    icon: "warning",
    title: "Warning!",
    text: msg,
    showConfirmButton: true,
    didClose: () => {
      if (nextfunction !== null) {
        nextfunction();
      }
    },
  });
};


export const Class_ETC_Encrypt = (value) => {
  let valueReturn = "";
  try {
    if (value === undefined || value === null) {
      valueReturn = "";
    } else {
      var CryptoJS = require("crypto-js");
      valueReturn = CryptoJS.AES.encrypt(
        value,
        ConfigETC.secretkey_cryptojs
      ).toString();
    }
  } catch {
    valueReturn = "";
  }
  return valueReturn;
};

export const Class_ETC_Decrypt = (value) => {
  let valueReturn = "";
  try {
    if (value === undefined || value === null) {
      valueReturn = "";
    } else {
      var CryptoJS = require("crypto-js");
      var bytes = CryptoJS.AES.decrypt(value, ConfigETC.secretkey_cryptojs);
      valueReturn = bytes.toString(CryptoJS.enc.Utf8);
    }
  } catch {
    valueReturn = "";
  }

  return valueReturn;
};

/* Add By POOM : 2023-10-09 ถ้า Encrypt2 จะต้องถอดด้วย Decrypt2 เท่านั้น
  ตัว Eecrypt2 จะต่างกับ Eecrypt ตรงที่ Eecrypt2 ถ้าเข้าด้วย value เดิม  จะ enc ออกมาเป็น ค่าเดิมเสมอ  แต่ Eecrypt จะได้ค่าสุ่มไปเรื่อยๆ
*/
export const Class_ETC_Encrypt2 = (value) => {
  let valueReturn = "";
  
  try {
    if (value === undefined || value === null) {
      valueReturn = "";
    } else {
      var CryptoJS = require("crypto-js");
      const key = CryptoJS.enc.Utf8.parse(ConfigETC.secretkey_cryptojs2);
      const iv = CryptoJS.enc.Utf8.parse(ConfigETC.secretkey_cryptojs3);


      valueReturn = CryptoJS.AES.encrypt(value, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
      }).toString();
    }
  } catch {
    valueReturn = "";
  }
  return valueReturn;
};


/* Add By POOM : 2023-10-09 ถ้า Encrypt2 จะต้องถอดด้วย Decrypt2 เท่านั้น
  ตัว Eecrypt2 จะต่างกับ Eecrypt ตรงที่ Eecrypt2 ถ้าเข้าด้วย value เดิม  จะ enc ออกมาเป็น ค่าเดิมเสมอ  แต่ Eecrypt จะได้ค่าสุ่มไปเรื่อยๆ
*/
export const Class_ETC_Decrypt2 = (value) => {
    let valueReturn = "";
    try {
      if (value === undefined || value === null) {
        valueReturn = "";
      } else {
        var CryptoJS = require("crypto-js");
        const key = CryptoJS.enc.Utf8.parse(ConfigETC.secretkey_cryptojs2);
        const iv = CryptoJS.enc.Utf8.parse(ConfigETC.secretkey_cryptojs3);
        
        valueReturn = CryptoJS.AES.decrypt(value, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }).toString(CryptoJS.enc.Utf8);
      }
    } catch {
      valueReturn = "";
    }
    return valueReturn;
};



export const Class_ETC_BindYear = (countyear) => {
  let ValueReturn = [];
  let year = new Date().getFullYear();
  let yearInt = parseInt(year);

  if (yearInt > 2222) {
    yearInt = yearInt - 543;
  }

  yearInt = yearInt - countyear;

  for (let i = 0; i < countyear * 2; i++) {
    ValueReturn.push({
      value: yearInt.toString(),
      label: yearInt.toString(),
    });
    yearInt++;
  }

  return ValueReturn;
};

export function CustomInputDate(props) {
  return (
    <div className="input-group">
      <input
        type="text"
        className="form-control form-control-sm"
        defaultValue={props.value}
        onClick={props.onClick}
        // onKeyDown={(e) => {
        //   e.preventDefault();
        // }}
      />
      <div className="input-group-append">
        <div className="input-group-text">
          <i className="fa fa-calendar" />
        </div>
      </div>
    </div>
  );
}

/// Add By POOM : 2023-05-19
/// รับค่ามาเป็น type Date แล้ว Return กลับไปเป็น  dd/mm/yyyy
/// โดยจะ  Return เป็น คศ เสมอ
export const Class_ETC_Return_dd_mm_yyyy = (DataDate) => {
  let ValueReturn = "";
  try {
    const yyyy = DataDate.getFullYear();
    let yy = parseInt(yyyy);
    let mm = DataDate.getMonth() + 1; // Months start at 0!
    let dd = DataDate.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    if (yy > 2222) yy = yy - 543;
    ValueReturn = dd + "/" + mm + "/" + yy.toString();
  } catch {
    ValueReturn = "";
  }

  return ValueReturn;
};

/// Add By POOM : 2023-05-22
/// รับค่ามาเป็น string โดย Format เป็น dd/MM/yyyy
/// จะ Returen ค่าออกไปเป็น date
export const Class_ETC_Convert_dd_MM_yyyy_ReturnDate = (DataDate) => {
  let ValueReturn = null;

  try {
    if (DataDate !== "") {
      var dateParts = DataDate.split("/");
      // month is 0-based, that's why we need dataParts[1] - 1
      ValueReturn = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    }
  } catch {
    ValueReturn = null;
  }

  return ValueReturn;
};

/// Add By Sittikron : 2023-06-01
export const Class_ETC_BindMonth = () => {
  let ValueReturn = [];

  ValueReturn.push(
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" }
  );

  return ValueReturn;
};

// Add By POOM : 2023-08-06  ปรับให้ แสดง Tooltip แบบ html
export const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: '#f5f5f9',
    backgroundColor: theme.palette.common.black,
    // color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    textAlign: "center",
    fontSize: "0.875rem",
    border: "1px solid #dadde9",
  },
}));

/* ############# Start #############
     Add By POOM 2023-06-27  
     สำหรับ React - select ในกรณีที่อยากได้  แสดง แบบ มี Group 
     โดย RSelect_Group จะแสดงข้อมูลที่เป็น Header Group เท่านั้น  ซึ่งจะเลือกไม่ได้   */
const RSelect_groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: "1rem",
  color: "#172B4D",
  backgroundColor:"#e2e8f0",
  padding: "0.25rem 0.5rem 0.25rem 0.5rem",
};

const RSelect_groupBadgeStyles = {
  backgroundColor: "#b0c9eb",
  borderRadius: "2em",
  color: "#172B4D",
  display: "inline-block",
  fontSize: "0.8rem",
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.16666666666667em 0.5em",
  textAlign: "top",
};

export const RSelect_Group = (data) => (
  <div style={RSelect_groupStyles}>
    <span>{data.label}</span>
    <span style={RSelect_groupBadgeStyles}>{data.options.length}</span>
  </div>
);
/* ############# End #############  */

/// Add By PRATAN : 2023-07-03
export const Bind_Presets_Calendar = () => {
  let ValueReturn = [];

  ValueReturn.push(
    { label: "Today", start: new Date(), end: new Date() },
    {
      label: "Yesterday",
      start: new Date(new Date().setDate(new Date().getDate() - 1)),
      end: new Date(new Date().setDate(new Date().getDate() - 1)),
    },
    {
      label: "Last 7 Days",
      start: new Date(new Date().setDate(new Date().getDate() - 6)),
      end: new Date(),
    },
    {
      label: "Last 30 Days",
      start: new Date(new Date().setDate(new Date().getDate() - 29)),
      end: new Date(),
    },

    {
      label: "This Week",
      start: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() - new Date().getDay()
      ),
      end: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() - new Date().getDay() + 6
      ),
    },
    {
      label: "This Month",
      start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    },
    {
      label: "Last Month",
      start: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      end: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    }
  );

  return ValueReturn;
};

// Add By F : 28/06/2023
// ฟังชั้น Convert เวลาจาก 29:59 เป็นนาที 1439
export const convertTimeToMinutes = (time) => {
  // แตก String ออกมาเก็บในตัวแปล
  
  let totalMinutes = 0
  try
  {
    if (time !== "")
    {
      const [hours, minutes] = time.split(":");
      // เอาตัวแปลชั่วโมงมา + 60 และ เอา + กับตัวแปลนาที และเก้บไว้ในตัวแปล totalMinutes
      totalMinutes = parseInt(hours) * 60 + parseInt(minutes);
      // Return ตัวแปล
    }
  }
  catch
  {
    totalMinutes = 0;
  }

  return totalMinutes;
};

// Add By PRATAN : 2023-07-05  ปรับการแสดงของ Tooltip
export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow placement="top" classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    maxWidth: 200,
    padding: "4px 8px",
    textAlign: "center",
    fontSize: 12,
  },
}));

/* ############# Start #############
     Add By Sittikron 2023-07-07  
     สำหรับ React - select ในกรณีที่อยากได้  แสดง แบบ มี DDL เมื่อ Click แม่ เท่ากับ Click เลือกลูกๆด้วย */

export const RSelect_Styles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.data.parent_id === 0 ? "#e2e8f0" : "white",
    color: state.data.parent_id === 0 ? "#495057" : "#495057",
    fontWeight: state.data.parent_id === 0 ? "bold" : "normal",
    // -----
    borderLeft: "3px solid #F5F5F5 !important",
    cursor: "pointer",
    "&:hover": { backgroundColor: "#F5F5F5" ,
                  borderLeft: "3px solid #0A1E5F !important"}

  }),
};
/* ############# End #############  */

/// Add By Sittikron : 2023-07-10
/// Edit By PRATAN : 2023-08-15 เพิ่ม page = Approve,Clearing
export const Bind_Select_Status = (page) => {
  let ValueReturn = [];
  if (page === "Rp_Sum_pro") {
    ValueReturn.push(
      {
        value: ConfigETC.TS_InProgress_Value,
        label: ConfigETC.TS_InProgress_Text,
      },
      { value: ConfigETC.TS_ToReview_Value, label: ConfigETC.TS_ToReview_Text },
      {
        value: ConfigETC.TS_ToApprove_Value,
        label: ConfigETC.TS_ToApprove_Text,
      },
      { value: ConfigETC.TS_Approved_Value, label: ConfigETC.TS_Approved_Text },
      { value: ConfigETC.TS_Reject_Value, label: ConfigETC.TS_Reject_Text },
      { value: ConfigETC.TS_Clearing_Value, label: ConfigETC.TS_Clearing_Text }
    );
  } else if (page === "MyTimeSheet") {
    ValueReturn.push(
      { value: -1, label: ConfigETC.ddl_All },
      {
        value: ConfigETC.TS_InProgress_Value,
        label: ConfigETC.TS_InProgress_Text,
      },
      { value: ConfigETC.TS_ToReview_Value, label: ConfigETC.TS_ToReview_Text },
      {
        value: ConfigETC.TS_ToApprove_Value,
        label: ConfigETC.TS_ToApprove_Text,
      },
      { value: ConfigETC.TS_Approved_Value, label: ConfigETC.TS_Approved_Text },
      { value: ConfigETC.TS_Reject_Value, label: ConfigETC.TS_Reject_Text },
      { value: ConfigETC.TS_Clearing_Value, label: ConfigETC.TS_Clearing_Text }
    );
  } else if (page === "Approve") {
    ValueReturn.push(
      { value: -1, label: ConfigETC.ddl_All },
      { value: ConfigETC.TS_ToReview_Value, label: ConfigETC.TS_ToReview_Text },
      {
        value: ConfigETC.TS_ToApprove_Value,
        label: ConfigETC.TS_ToApprove_Text,
      },
      { value: ConfigETC.TS_Approved_Value, label: ConfigETC.TS_Approved_Text }
    );
  } else if (page === "Clearing") {
    ValueReturn.push(
      { value: -1, label: ConfigETC.ddl_All },
      { value: ConfigETC.TS_Approved_Value, label: ConfigETC.TS_Approved_Text }
    );
  } else if (page === "PVTimesheetbyStaff") {
    ValueReturn.push(
      { value: ConfigETC.TS_ToReview_Value, label: ConfigETC.TS_ToReview_Text },
      {
        value: ConfigETC.TS_ToApprove_Value,
        label: ConfigETC.TS_ToApprove_Text,
      },
      { value: ConfigETC.TS_Approved_Value, label: ConfigETC.TS_Approved_Text },
      { value: ConfigETC.TS_Reject_Value, label: ConfigETC.TS_Reject_Text },
      { value: ConfigETC.TS_Clearing_Value, label: ConfigETC.TS_Clearing_Text }
    );
  }

  return ValueReturn;
};

/* 
      Add By Sittikron 2023-07-2023 
      Update By Sittikron 2023-08-09  
      สำหรับ การ Connvert ค่า Date ธรรมดา (Sun Jul 16 2023 10:44:39 GMT+0700 (เวลาอินโดจีน) 
      วิธีการใช้ ประกาศ ตัวหนึ่ง มาเป็นค่ารับค่า New Date 
      const DatetoConvert = new Date();
      const Datetouse = formatDate(DatetoConvert,"short en","th","/","datetime");
      โดยการรับ Parameter 5 ตัว ได้แก่
                            1 date ก็ค่า Date จาก new Date() มาเพื่อ Formate Date
                            2 actmonth คือ การกำหนกรูปแบบ ของเดือน โดยหากต้องการเป็นตัวอักษร เช่น มกราคม หรือ January ให้คำหน้าเป็นคำวว่า full และ ขั้นด้วย " " และปิดท้้ายด้วยเลือก ภาษาของเดือน หากต้องการเป็น ภาษาไทยให้่เป็น th และ ภาษาอังกฤษ ให้เเป็น en
                              แต่หากเดือนเป็นตัวเลขปกติไม่ให้คำหน้าเป็น full ให้ใช้คำว่า short และเเว้นวรรค เช่น "short " ตัวคำในการใช้ "full en" , "full th" , "short "
                            3 actyear คือการเลือกปีเป็น ค.ศ. หรือ พ.ศ. หากต้อง พ.ศ. ให้ใช้ th และ ค.ศ. ให้ใช้ en
                            4 comma คือตัวขั้นระหว่าง วันเดือนปี เช่น 01/01/2023
                            5 type คือรูปแบบ Return โดยจะมี 3 รูปแบบดังนี้
                              5.1  general_date = วันเดือนปีไม่มีเวลา เช่น 01/01/2023 หรือ 01 มกราคม 2566
                              5.2  datetime = วันเดือนปีมีชั่วโมงนาทีแต่ไม่มีวินาที  เช่น 01/01/2023 12:30 หรือ 01 มกราคม 2566 12:30
                              5.3  datetimesec = วันเดือนปีมีชั่วโมงนาทีและ วินาที  เช่น 01/01/2023 12:30:59 หรือ 01 มกราคม 2566 12:30:59
                              5.4  datetimeexport = ปีเดือนวันไม่มีตัวอักษรกั้นและมีชั่วโมงกับนาที เช่น 20230101_1230
    */
export const formatDate = (date, actmonth, actyear, comma, type) => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  const monthsplit = actmonth.split(" ");

  if (monthsplit.length === 2) {
    const monthtype = monthsplit[0];
    const monthlanguage = monthsplit[1];
    const monthinuse =
      monthtype === "full" ? getMonthName(Number(month), monthlanguage) : month;

    const yearuse =
      actyear === "en"
        ? Number(year) > 2222
          ? Number(year) - 543
          : year
        : actyear === "th"
        ? Number(year) < 2222
          ? Number(year) + 543
          : year
        : year;

    if (type === "general_date") {
      return `${day}${comma}${monthinuse}${comma}${yearuse}`;
    } else if (type === "datetime") {
      return `${day}${comma}${monthinuse}${comma}${yearuse} ${hours}:${minutes}`;
    } else if (type === "datetimesec") {
      return `${day}${comma}${monthinuse}${comma}${yearuse} ${hours}:${minutes}:${seconds}`;
    } else if (type === "datetimeexport") {
      return `${yearuse}${monthinuse}${day}_${hours}${minutes}`;
    } else {
      return "";
    }
  } else {
    return "";
  }
};
/* 
        Add By Sittikron 09-08-2023  
        สำหรับ การแก้ไข Format date ให้เป็น พ.ศ. หรือ ค.ศ. และ เดือน ภาษาไทย หรือ ภาษาอังกฤษ
        วิธีการใช้ ให้ส่งค่า Date มาเป็น string ในรูปแบบที่มี / เช่น "01/01/2023"
                const Datetouse = formatDate(DatetoConvert,"short en","th","/");
                โดยการรับ Parameter 4 ตัว ได้แก่
                            1 date ก็ค่า Date จาก string เช่น Date = "01/01/2023"
                            2 actmonth คือ การกำหนกรูปแบบ ของเดือน โดยหากต้องการเป็นตัวอักษร เช่น มกราคม หรือ January ให้คำหน้าเป็นคำวว่า full และ ขั้นด้วย " " และปิดท้้ายด้วยเลือก ภาษาของเดือน หากต้องการเป็น ภาษาไทยให้่เป็น th และ ภาษาอังกฤษ ให้เเป็น en
                             แต่หากเดือนเป็นตัวเลขปกติไม่ให้คำหน้าเป็น full ให้ใช้คำว่า short และเเว้นวรรค เช่น "short " ตัวคำในการใช้ "full en" , "full th" , "short "
                            3 actyear คือการเลือกปีเป็น ค.ศ. หรือ พ.ศ. หากต้อง พ.ศ. ให้ใช้ th และ ค.ศ. ให้ใช้ en
                            4 comma คือตัวขั้นระหว่าง วันเดือนปี เช่น 01/01/2023
    */
export const formatDatestr = (date, actmonth, actyear, comma) => {
  const dateuse = date.split("/");
  const monthsplit = actmonth.split(" ");

  if (dateuse.length === 3 && monthsplit.length === 2) {
    const day = dateuse[0];
    const month = dateuse[1];
    const year = dateuse[2];
    const monthtype = monthsplit[0];
    const monthlanguage = monthsplit[1];

    const yearuse =
      actyear === "en"
        ? Number(year) > 2222
          ? Number(year) - 543
          : year
        : actyear === "th"
        ? Number(year) < 2222
          ? Number(year) + 543
          : year
        : year;

    const monthName =
      monthtype === "full" ? getMonthName(Number(month), monthlanguage) : month;
    return `${day}${comma}${monthName}${comma}${yearuse}`;
  } else {
    return "";
  }
};
/* 
      Add By Sittikron 09-08-2023  
      สำหรับ การแก้ไข Format เดือนจาก ตัวเลขมาเป็นตัวอักษร ตัวอย่าง 01 เป็น มกราคม หรือ January
      วิธีการใช้ const month = getMonthName(monthNum,"th");
              โดยการรับ Parameter 2 ตัว ได้แก่
                          1 monthNumber ค่า ตัวเลข สำหรับ convert เป็นเดือนตัวอักษร
                          2 act คือ สำหรับเลือกเดือนเป็นภาษาอังกฤษหรือภาษาไทย
    */
export const getMonthName = (monthNumber, act) => {
  const engMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const thaiMonths = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];
  const months = act === "th" ? thaiMonths : engMonths;
  return months[monthNumber - 1] || "";
};

/// Add By Sittikron : 2023-07-10
/// เป็น Toolbar สำหรับ DataGrid ใน Synfusion ใช้ในหน้า Report1,2 และ 3
export const datagridtoolbarOptions = (listReport) => [
  {
    text: `Result ( ${listReport.length} item)`,
    tooltipText: `Result ${listReport.length}`,
    id: "Result",
    align: "Left",
    prefixIcon: "e-icons e-description",
  },
  {
    text: "ExcelExport",
    tooltipText: "ExcelExport",
    id: "ExcelExport",
    align: "Right",
  },
  {
    text: "PdfExport",
    tooltipText: "PdfExport",
    id: "PdfExport",
    align: "Right",
  },
  {
    text: "CsvExport",
    tooltipText: "CsvExport",
    id: "CsvExport",
    align: "Right",
  },
  { text: "Print", tooltipText: "Print", id: "Print", align: "Right" },
];

/// Add By Sittikron : 2023-07-10
/// เป็น เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Report1,2 และ 3
export const pdfExportProperties_Reportsummary = (
  FileName,
  Report,
  Des,
  Customer,
  Project,
  Task,
  Staffs,
  Daterang,
  Status,
  DateExport
) => {
  if (Customer === "") {
    Customer = ConfigETC.ddl_All;
  }
  if (Project === "") {
    Project = ConfigETC.ddl_All;
  }
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }
  if (Staffs === "") {
    Staffs = ConfigETC.ddl_All;
  }
  if (Daterang === "") {
    Daterang = ConfigETC.ddl_All;
  }
  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 160,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: Report,
          position: { x: 455, y: 30 },
          style: {
            font: { size: "40", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: Des,
          position: { x: 405, y: 60 },
          style: {
            font: { size: "20", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Customer : ${Customer}`,
          position: { x: 1, y: 90 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Project : ${Project}`,
          position: { x: 1, y: 100 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staffs}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Daterang}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 140 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};


/// Add By POOM : 2023-08-30
/// เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Report Position , Transaction
///
/// Update By Krisana : 2024-05-08
/// เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Report Position , Transaction และ Staffs
/// - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer
export const pdfExportProperties_Reportsummary_Pos_Tran = (
  FileName,
  ReportName1,
  ReportName2,
  Customer,
  Project,
  Task,
  Timeoff,
  Staff,
  Date,
  Status,
  DateExport
) => {
  if (Customer === "") {
    Customer = ConfigETC.ddl_All;
  }

  if (Project === "") {
    Project = ConfigETC.ddl_All;
  }
  
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }
  
  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 170,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: ReportName1,
          position: { x: 455, y: 30 },
          style: {
            font: { size: "40", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: ReportName2,
          position: { x: 405, y: 60 },
          style: {
            font: { size: "20", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Customer : ${Customer}`,
          position: { x: 1, y: 90 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Project : ${Project}`,
          position: { x: 1, y: 100 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Time Off : ${Timeoff}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staff}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Date}`,
          position: { x: 1, y: 140 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 150 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};


/// Add By Sittikron : 2023-07-10
/// เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Report1,2 และ 3
///
/// Update By Krisana : 2024-05-03
/// - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer
///
/// Update By POOM : 2024-05-14
/// - เพิ่ม colSpan 

export const excelExportProperties_Reportsummary = (
  FileName,
  Report,
  Des,
  Customer,
  Project,
  Task,
  Staffs,
  Daterang,
  Status,
  DateExport,
  colSpan
  
) => {
  if (Customer === "") {
    Customer = ConfigETC.ddl_All;
  }
  if (Project === "") {
    Project = ConfigETC.ddl_All;
  }
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }
  if (Staffs === "") {
    Staffs = ConfigETC.ddl_All;
  }
  if (Daterang === "") {
    Daterang = ConfigETC.ddl_All;
  }
  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    fileName: FileName,
    header: {
      headerRows: 8,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: Report,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: Des,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Customer : ${Customer}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${Project}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staffs}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Daterang}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};


/// Add By Poom : 2023-08-30
/// เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Report Position , Transaction
///
/// Update By Krisana : 2024-05-08
/// เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Report Position , Transaction และ Staffs
/// - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer
export const excelExportProperties_Reportsummary_Pos_Tran = (
  FileName,
  ReportName1,
  ReportName2,
  Customer,
  Project,
  Task,
  Timeoff,
  Staff,
  Date,
  Status,
  colSpan,
  DateExport
) => {
  if (Customer === "") {
    Customer = ConfigETC.ddl_All;
  }

  if (Project === "") {
    Project = ConfigETC.ddl_All;
  }

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    fileName: FileName,
    header: {
      headerRows: 9,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName1,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName2,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Customer : ${Customer}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${Project}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Time Off : ${Timeoff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};


/// Add By Poom : 2023-08-24
/// เป็น เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Project View ในส่วนของ Transaction
export const excelExportProperties_ProjectView_Transaction = (
  FileName,
  ReportName,
  ProjectName,
  Task,
  Staff,
  Timeoff,
  Date,
  Status,
  colSpan,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  
  return {
    fileName: FileName,
    header: {
      headerRows: 7,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ProjectName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Time Off : ${Timeoff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};
  
/// Add By Pratan : 2023-10-02
/// เป็น เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Project View ในส่วนของ Transaction
export const pdfExportProperties_ProjectView_Transaction = (
  FileName,
  ReportName,
  ProjectName,
  Task,
  Staff,
  Timeoff,
  Date,
  Status,
  DateExport
) => {

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 150,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: ReportName,
          position: { x: 0, y: 30 },
          style: {
            font: { size: "40", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: ProjectName,
          position: { x: 0, y: 60 },
          style: {
            font: { size: "20", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Date}`,
          position: { x: 1, y: 90 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },   
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 100 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staff}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Time Off : ${Timeoff}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};

/// Add By Pratan : 2023-10-04
/// เป็น เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Project View ในส่วนของ Transaction
export const csvExportProperties_ProjectView_Transaction = (
  FileName,
  ReportName,
  ProjectName,
  Task,
  Staff,
  Timeoff,
  Date,
  Status,
  colSpan,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    fileName: FileName,
    header: {
      headerRows: 7,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ProjectName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Time Off : ${Timeoff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};


/// Add By Poom : 2023-09-18
/// เป็น เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Project View ในส่วนของ Timesheetbyperiod
export const excelExportProperties_ProjectView_Timesheetbyperiod = (
  FileName,
  ReportName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Timeoff,
  Date,
  Status,
  colSpan,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    fileName: FileName,
    header: {
      headerRows: 8,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ProjectName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Time Off : ${Timeoff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};

/// Add By Pratan : 2023-10-04
/// เป็น เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Project View ในส่วนของ Timesheetbyperiod
export const pdfExportProperties_ProjectView_Timesheetbyperiod = (
  FileName,
  ReportName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Timeoff,
  Date,
  Status,
  DateExport
) => {

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }
  
  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 160,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: ReportName,
          position: { x: 0, y: 30 },
          style: {
            font: { size: "40", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: ProjectName,
          position: { x: 0, y: 60 },
          style: {
            font: { size: "20", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `View data by : ${GroupBy}`,
          position: { x: 1, y: 90 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },     
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Date}`,
          position: { x: 1, y: 100 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },   
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staff}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Time Off : ${Timeoff}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 140 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};

/// Add By Pratan : 2023-10-04
/// เป็น เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Project View ในส่วนของ Timesheetbyperiod
export const csvExportProperties_ProjectView_Timesheetbyperiod = (
  FileName,
  ReportName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Timeoff,
  Date,
  Status,
  colSpan,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    fileName: FileName,
    header: {
      headerRows: 8,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ProjectName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Time Off : ${Timeoff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};


/// Add By Sittikron : 2023-07-10
/// เป็น เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Report1,2 และ 3
///
/// Update By POOM : 2024-05-14
/// - เพิ่ม colSpan 

export const csvExportProperties_Reportsummary = (
  FileName,
  Report,
  Des,
  Customer,
  Project,
  Task,
  Staffs,
  Daterang,
  Status,
  DateExport,
  colSpan
) => {
  if (Customer === "") {
    Customer = ConfigETC.ddl_All;
  }
  if (Project === "") {
    Project = ConfigETC.ddl_All;
  }
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }
  if (Staffs === "") {
    Staffs = ConfigETC.ddl_All;
  }
  if (Daterang === "") {
    Daterang = ConfigETC.ddl_All;
  }
  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    fileName: FileName,
    header: {
      headerRows: 8,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: Report,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: Des,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Customer : ${Customer}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${Project}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staffs}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Daterang}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
  };
};


/// Add By POOM : 2023-08-30
/// เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Report Position , Transaction
///
/// Update By Krisana : 2024-05-08
/// เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Report Position , Transaction และ Staffs
/// - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer
export const csvExportProperties_Reportsummary_Pos_Tran = (
  FileName,
  ReportName1,
  ReportName2,
  Customer,
  Project,
  Task,
  Timeoff,
  Staff,
  Date,
  Status,
  colSpan,
  DateExport
) => {
  if (Customer === "") {
    Customer = ConfigETC.ddl_All;
  }

  if (Project === "") {
    Project = ConfigETC.ddl_All;
  }

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }
  
  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    fileName: FileName,
    header: {
      headerRows: 9,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName1,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName2,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Customer : ${Customer}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${Project}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Time Off : ${Timeoff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
  };
};


/// Add By Sittikron : 2023-07-xx
/// ย้ายโดย POOM ย้ายจาก function ที่ Report มาใส่ตรง Class Etc
/// Update By Sittikron :2023-08-09 แก้ไข paremeter formatDate
/// จะ Return this week ออกมา
export const Return_thisWeekDate = () => {
  let weekRange = "";
  try {
    const currentDate = new Date();
    const firstDayOfWeek = new Date(
      currentDate.setDate(currentDate.getDate() - currentDate.getDay())
    );
    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);
    const formattedFirstDay = formatDate(
      firstDayOfWeek,
      "short ",
      "en",
      "/",
      "general_date"
    );
    const formattedLastDay = formatDate(
      lastDayOfWeek,
      "short ",
      "en",
      "/",
      "general_date"
    );
    weekRange = `${formattedFirstDay} - ${formattedLastDay}`;
  } catch {
    weekRange = "";
  }

  return weekRange;
};

/// Add By POOM : 2023-08-23
/// return  week date start - week date end ของ week ปัจจุบัน แบบ array
export const Return_thisWeekDate_Array = () => {
  //DateStart_td = วันที่เริ่มต้น week แบบ type date
  //DateEnd_td = วันที่เริ่มต้น week แบบ type date
  //DateStart_ts = วันที่เริ่มต้น week แบบ type string รูปแบบ dd/mm/yyyy
  //DateEnd_ts = วันที่เริ่มต้น week แบบ type string รูปแบบ dd/mm/yyyy
  let ValueReturn = {
    DateStart_td: null,
    DateEnd_td: null,
    DateStart_ts: null,
    DateEnd_ts: null,
  };
  try {
    ValueReturn.DateStart_td = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - new Date().getDay()
    );
    ValueReturn.DateEnd_td = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - new Date().getDay() + 6
    );

    ValueReturn.DateStart_ts = formatDate(
      ValueReturn.DateStart_td,
      "short ",
      "en",
      "/",
      "general_date"
    );
    ValueReturn.DateEnd_ts = formatDate(
      ValueReturn.DateEnd_td,
      "short ",
      "en",
      "/",
      "general_date"
    );
  } catch {}
  return ValueReturn;
};

/// Add By Kai : 18 AUG 2023
/// ส่ง นาที และจะ Return วัน ชม นาท เช่น 3360 --> 2d 8h โดย 1 day จะนับ 24 hr
export const ConvertMiniutDuration = (minutes) => {
  let rstr = "";

  if (Math.floor(minutes / 60 / 24) !== 0) {
    rstr += Math.floor(minutes / 60 / 24) + "d ";
  }

  if (Math.floor(minutes / 60) % 24 !== 0) {
    rstr += (Math.floor(minutes / 60) % 24) + "h ";
  }

  if (minutes % 60 !== 0) {
    rstr += (minutes % 60) + "m";
  }

  return rstr;
};


/// Add By Poom : 21/09/2023
/// ส่ง นาที และจะ Return วัน ชม นาท เช่น 3360 --> 2d 8h  โดย 1 day จะนับ ตาม config ที่ setting ไว้
export const ConvertMiniutDuration_calbyconfig = (minutes) => {
  
  let rstr = "";
  let workday_WT = localStorage.getItem("workday_WT");

  let minperDay = 0;
  try
  {
    if (!isNaN(workday_WT)) {
      minperDay = parseInt(workday_WT);
    } else {
      minperDay = 0;
    }
  }
  catch {
    minperDay = 0;
  }


  if (Math.floor(minutes / minperDay) !== 0) {
    rstr += Math.floor(minutes / minperDay) + "d ";
  }

  if (Math.floor(minutes % minperDay / 60)  !== 0) {
    rstr += (Math.floor(minutes % minperDay / 60)) + "h ";
  }

  if (((minutes % minperDay) %60) !== 0) {
    rstr += ((minutes % minperDay) % 60) + "m";
  }

  return rstr;
};


/// Add By Kai : 18 Aug 2023
/// เป็น Toolbar สำหรับ DataGrid ใน Synfusion โดย จะให้ส่ง parameter
/// listReport = data
/// isShowResult = true, false  คือการแสดงจำนวนข้อมูล
/// isExcel = true, false  คือการแสดงปุ่ม Excel Export
/// isPdf = true, false คือการแสดงปุ่ม PDF Export
/// isCSV = true, false  คือการแสดงปุ่ม CSV Export
/// isPrint = true, false  คือการแสดงปุ่ม Print Export
export const datagridtoolbarDynamicOptions = (
  listReport,
  isShowResult,
  isExcel,
  isPdf,
  isCSV,
  isPrint
) => [
  {
    text: `Result ( ${listReport.length} item)`,
    tooltipText: `Result ${listReport.length}`,
    id: "Result",
    align: "Left",
    prefixIcon: "e-icons e-description",
    visible: isShowResult,
  },
  {
    text: "ExcelExport",
    tooltipText: "ExcelExport",
    id: "ExcelExport",
    align: "Right",
    visible: isExcel,
  },
  {
    text: "PdfExport",
    tooltipText: "PdfExport",
    id: "PdfExport",
    align: "Right",
    visible: isPdf,
  },
  {
    text: "CsvExport",
    tooltipText: "CsvExport",
    id: "CsvExport",
    align: "Right",
    visible: isCSV,
  },
  {
    text: "Print",
    tooltipText: "Print",
    id: "Print",
    align: "Right",
    visible: isPrint,
  },
];

/// Add By Kai : 18 Aug 2023
/// เป็น Exel Header
/// เป็น เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Project View ในส่วนของ Department
export const excelExportProperties_ProjectView_GropBy = (
  FileName,
  ReportName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  colspan,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 7,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ProjectName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};

/// Add By Pratan : 2023-10-03
/// เป็น เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Project View ในส่วนของ Department
export const pdfExportProperties_ProjectView_GropBy = (
  FileName,
  ReportName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 150,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: ReportName,
          position: { x: 0, y: 30 },
          textAlignment : "Center",
          style: {
            font: { size: "40", bold: true , hAlign: 'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: ProjectName,
          position: { x: 0, y: 60 },
          style: {
            font: { size: "20", bold: true , hAlign:'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `View data by : ${GroupBy}`,
          position: { x: 1, y: 90 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },     
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Date}`,
          position: { x: 1, y: 100 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },   
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staff}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};

/// Add By Pratan : 2023-10-02
/// เป็น เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Project View ในส่วนของ Department
export const csvExportProperties_ProjectView_GropBy = (
  FileName,
  ReportName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  colspan,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 7,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ProjectName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};

/// Add By Sittikron : 25 Aug 2023
/// ใช้ในหน้า Report สำหรับ เปลี่ยนค่าจาก 0.00 เป็นค่าว่าง ""
export const Returnhidevalue = (value) => {
  let rstr = "";
  rstr = value === 0.0 || value === 0 ? "" : value;
  return rstr;
};


/// Add By POOM : 22/09/2023
/// เป็น Exel Header
/// เป็น เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Project View ในส่วนของ Staff
export const excelExportProperties_ProjectViewStaff_GropBy = (
  FileName,
  ReportName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  Dept,
  Position,
  colspan,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  if (Dept === "") {
    Dept = ConfigETC.ddl_All;
  }

  if (Position === "") {
    Position = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 9,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ProjectName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Department : ${Dept}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Position : ${Position}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};

/// Add By Pratan : 2023-10-04
/// เป็น เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Project View ในส่วนของ Staff
export const pdfExportProperties_ProjectViewStaff_GropBy = (
  FileName,
  ReportName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  Dept,
  Position,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  if (Dept === "") {
    Dept = ConfigETC.ddl_All;
  }

  if (Position === "") {
    Position = ConfigETC.ddl_All;
  }


  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 170,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: ReportName,
          position: { x: 0, y: 30 },
          textAlignment : "Center",
          style: {
            font: { size: "40", bold: true , hAlign: 'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: ProjectName,
          position: { x: 0, y: 60 },
          style: {
            font: { size: "20", bold: true , hAlign:'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `View data by : ${GroupBy}`,
          position: { x: 1, y: 90 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },     
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Date}`,
          position: { x: 1, y: 100 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },   
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staff}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Department : ${Dept}`,
          position: { x: 1, y: 140 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Position : ${Position}`,
          position: { x: 1, y: 150 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};

/// Add By Pratan : 2023-10-04
/// เป็น เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Project View ในส่วนของ Staff
export const csvExportProperties_ProjectViewStaff_GropBy = (
  FileName,
  ReportName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  Dept,
  Position,
  colspan,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  if (Dept === "") {
    Dept = ConfigETC.ddl_All;
  }

  if (Position === "") {
    Position = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 9,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ProjectName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Department : ${Dept}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Position : ${Position}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};




/// Add By POOM : 22/09/2023
/// Return ตัวเลขให้อยู่ในรูปแบบ xx,xxx.xx โดย Fix ที่ทศนิยม 2 ต่ำแหน่ง
export const Returncomma = (value) => {
  
  let numberWithCommasAndDecimals = "0";

  try
  {
    let number = parseFloat(value); // เปลี่ยนตัวเลขตามที่คุณต้องการแสดง
    numberWithCommasAndDecimals = number.toLocaleString('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2, // จำนวนตัวเลขหลังจุดทศนิยม
      maximumFractionDigits: 2, // จำนวนตัวเลขหลังจุดทศนิยม
    });
  }
  catch{
    numberWithCommasAndDecimals = "0";
  }
  
  return numberWithCommasAndDecimals;
};

/// Add By POOM : 22/09/2023
/// เป็น Return ตัวเลขให้อยู่ในรูปแบบ xx,xxx.xx  หรือ xx,xxx  ตาม mindig-maxdig ที่ส่งเข้ามา
export const ReturncommaCustom = (value , mindig , maxdig) => {
  
  let numberWithCommasAndDecimals = "0";

  try
  {
    let number = parseFloat(value); // เปลี่ยนตัวเลขตามที่คุณต้องการแสดง
    numberWithCommasAndDecimals = number.toLocaleString('en-US', {
      style: 'decimal',
      minimumFractionDigits: mindig, // จำนวนตัวเลขหลังจุดทศนิยม
      maximumFractionDigits: maxdig, // จำนวนตัวเลขหลังจุดทศนิยม
    });
  }
  catch{
    numberWithCommasAndDecimals = "0";
  }
  
  return numberWithCommasAndDecimals;
};



/// Add By Sittikron : 26/09/2023
/// ใช้สำหรับแก้สไตล์ Pagin ของ synfusion
L10n.load({
  'en-US': { 
    pager: { 
      currentPageInfo: '{0} - {1} ',
      totalItemsInfo: 'of {0}',
    },
  },
});

export const customStylesSelect = {
  ///.....
  menuPortal: provided => ({ ...provided, zIndex: 9999 }),
  //menu: provided => ({ ...provided, zIndex: 9999 }),

  option: (provided, state) => ({
    ...provided,
    fontWeight: "400",
    color: "#495057",
    borderLeft: "3px solid #F5F5F5 !important",
    backgroundColor: "white",
    fontSize: "1rem",
    padding: "0.25rem 0.5rem 0.25rem 0.5rem",
    cursor: "pointer",
    "&:hover": { backgroundColor: "#F5F5F5" ,
                  borderLeft: "3px solid #0A1E5F !important"}
  }),
  ///.....
}


/// Add By Pratan : 2023-10-02
/// เป็น เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Report Timesheet by period
///
/// Update By Krisana : 2024-05-09
/// - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer
export const excelExportProperties_Report_Timesheetbyperiod = (
  FileName,
  ReportName1,
  ReportName2,
  Customer,
  Project,
  GroupBy,
  Task,
  Staff,
  Timeoff,
  Date,
  Status,
  colSpan,
  DateExport
) => {
  if (Customer === "") {
    Customer = ConfigETC.ddl_All;
  }

  if (Project === "") {
    Project = ConfigETC.ddl_All;
  }
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    fileName: FileName,
    header: {
      headerRows: 10,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName1,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName2,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Customer : ${Customer}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${Project}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Time Off : ${Timeoff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};

/// Add By Pratan : 2023-10-02
/// เป็น เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Report Timesheet by period
///
/// Update By Krisana : 2024-05-09
/// - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer
export const pdfExportProperties_Report_Timesheetbyperiod = (
  FileName,
  ReportName1,
  ReportName2,
  Customer,
  Project,
  GroupBy,
  Task,
  Staff,
  Timeoff,
  Date,
  Status,
  DateExport
) => {
  if (Customer === "") {
    Customer = ConfigETC.ddl_All;
  }

  if (Project === "") {
    Project = ConfigETC.ddl_All;
  }
  
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }
  
  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 180,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: ReportName1,
          position: { x: 0, y: 30 },
          style: {
            font: { size: "40", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: ReportName2,
          position: { x: 0, y: 60 },
          style: {
            font: { size: "20", bold: true },
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `View data by : ${GroupBy}`,
          position: { x: 1, y: 90 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },     
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Date}`,
          position: { x: 1, y: 100 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },   
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staff}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Customer : ${Customer}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Project : ${Project}`,
          position: { x: 1, y: 140 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Time Off : ${Timeoff}`,
          position: { x: 1, y: 150 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 160 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};

/// Add By Pratan : 2023-10-02
/// เป็น เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Report Timesheet by period
///
/// Update By Krisana : 2024-05-09
/// - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer
export const csvExportProperties_Report_Timesheetbyperiod = (
  FileName,
  ReportName1,
  ReportName2,
  Customer,
  Project,
  GroupBy,
  Task,
  Staff,
  Timeoff,
  Date,
  Status,
  colSpan,
  DateExport

) => {
  if (Customer === "") {
    Customer = ConfigETC.ddl_All;
  }

  if (Project === "") {
    Project = ConfigETC.ddl_All;
  }

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }
  
  if (Timeoff === "") {
    Timeoff = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    fileName: FileName,
    header: {
      headerRows: 10,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName1,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName2,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Customer : ${Customer}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${Project}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Time Off : ${Timeoff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
  };
};


export const date_pickerStyle = {  
  marginTop: "3px",  
  marginBottom: "3px" 
}; 



/// Add By POOM : 2024-05-29
/// เป็น Exel Header
/// เป็น เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า customer View ในส่วนของ Department
export const excelExport_CV_Dept_GropBy = (
  FileName,
  ReportName,
  Customer,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  colspan,
  DateExport
) => {
  
  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (ProjectName === "") {
    ProjectName = ConfigETC.ddl_All;
  }

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 8,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: Customer,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${ProjectName}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};


/// Add By Poom : 2024-05-29
/// เป็น เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า customer View ในส่วนของ Department
export const pdfExport_CV_Dept_GropBy = (
  FileName,
  ReportName,
  CustomerName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  DateExport
) => {

  if (ProjectName === "") {
    ProjectName = ConfigETC.ddl_All;
  }


  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 190,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: ReportName,
          position: { x: 0, y: 30 },
          textAlignment : "Center",
          style: {
            font: { size: "40", bold: true , hAlign: 'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: CustomerName,
          position: { x: 0, y: 80 },
          style: {
            font: { size: "20", bold: true , hAlign:'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `View data by : ${GroupBy}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },     
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Date}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },   
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Project : ${ProjectName}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 140 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staff}`,
          position: { x: 1, y: 150 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 160 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};


/// Add By Poom : 2024-05-29
/// เป็น เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Customer View ในส่วนของ Department
export const csvExport_CV_Dept_GropBy = (
  FileName,
  ReportName,
  CustomerName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  colspan,
  DateExport
) => {
    
  if (ProjectName === "") {
    ProjectName = ConfigETC.ddl_All;
  }

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 8,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: CustomerName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${ProjectName}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};



/// Add By POOM : 29/05/2024
/// เป็น Exel Header
/// เป็น เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Customer View ในส่วนของ Staff
export const excelExport_CV_Staff_GropBy = (
  FileName,
  ReportName,
  CustomerName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  Dept,
  Position,
  colspan,
  DateExport
) => {


  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (ProjectName === "") {
    ProjectName = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  if (Dept === "") {
    Dept = ConfigETC.ddl_All;
  }

  if (Position === "") {
    Position = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 10,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: CustomerName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${ProjectName}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Department : ${Dept}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Position : ${Position}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};


/// Add By POOM : 2024-05-29
/// เป็น เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Customer View ในส่วนของ Staff
export const pdfExport_CV_Staff_GropBy = (
  FileName,
  ReportName,
  CustomerName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  Dept,
  Position,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (ProjectName === "") {
    ProjectName = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  if (Dept === "") {
    Dept = ConfigETC.ddl_All;
  }

  if (Position === "") {
    Position = ConfigETC.ddl_All;
  }


  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 200,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: ReportName,
          position: { x: 0, y: 30 },
          textAlignment : "Center",
          style: {
            font: { size: "40", bold: true , hAlign: 'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: CustomerName,
          position: { x: 0, y: 80 },
          style: {
            font: { size: "20", bold: true , hAlign:'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `View data by : ${GroupBy}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },     
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Date}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },   
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staff}`,
          position: { x: 1, y: 140 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 150 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Project : ${ProjectName}`,
          position: { x: 1, y: 160 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Department : ${Dept}`,
          position: { x: 1, y: 170 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Position : ${Position}`,
          position: { x: 1, y: 180 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};


/// Add By POOM : 2024-05-29
/// เป็น เป็นค่า Setting รูปการ Export file CSV ใช้ในหน้า Customer View ในส่วนของ Staff
export const csvExport_CV_Staff_GropBy = (
  FileName,
  ReportName,
  CustomerName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  Dept,
  Position,
  colspan,
  DateExport
) => {
  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (ProjectName === "") {
    ProjectName = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  if (Dept === "") {
    Dept = ConfigETC.ddl_All;
  }

  if (Position === "") {
    Position = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 10,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: CustomerName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${ProjectName}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Department : ${Dept}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Position : ${Position}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};



/// Add By POOM : 2024-05-30
/// เป็น Exel Header
/// เป็น เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า Customer View ในส่วนของ Task
export const excelExpor_CV_Task_GropBy = (
  FileName,
  ReportName,
  CustomerName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  colspan,
  DateExport
) => {

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }
  
  if (ProjectName === "") {
    ProjectName = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 8,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: CustomerName,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${ProjectName}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};


/// Add By POOM : 2024-05-30
/// เป็น เป็นค่า Setting รูปการ Export file PDF ใช้ในหน้า Customer View ในส่วนของ Task
export const pdfExport_CV_Task_GropBy = (
  FileName,
  ReportName,
  CustomerName,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  DateExport
) => {

  if (ProjectName === "") {
    ProjectName = ConfigETC.ddl_All;
  }

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  return {
    theme: {
      caption: { font: new PdfTrueTypeFont(adventProFont, 10) },
      header: { font: new PdfTrueTypeFont(adventProFont, 10) },
      record: { font: new PdfTrueTypeFont(adventProFont, 10) },
    },
    pageOrientation: "Landscape",
    pageSize: "A4",
    allowHorizontalOverflow: false,
    fileName: FileName,
    header: {
      fromTop: 0,
      height: 190,
      contents: [
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 40),
          value: ReportName,
          position: { x: 0, y: 30 },
          textAlignment : "Center",
          style: {
            font: { size: "40", bold: true , hAlign: 'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 20),
          value: CustomerName,
          position: { x: 0, y: 80 },
          style: {
            font: { size: "20", bold: true , hAlign:'Center'},
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `View data by : ${GroupBy}`,
          position: { x: 1, y: 110 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },     
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Date : ${Date}`,
          position: { x: 1, y: 120 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },   
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Project : ${ProjectName}`,
          position: { x: 1, y: 130 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Task : ${Task}`,
          position: { x: 1, y: 140 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Staffs : ${Staff}`,
          position: { x: 1, y: 150 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
        {
          type: "Text",
          font: new PdfTrueTypeFont(adventProFont, 9),
          value: `Status : ${Status}`,
          position: { x: 1, y: 160 },
          style: {
            overflow: "auto",
            whiteSpace: "pre-wrap",
          },
        },
      ],
    },
    footer: {
      contents: [
        {
          format: "Page {$current} of {$total}",
          pageNumberType: "Arabic",
          position: { x: 0, y: 0 },
          style: {
            fontSize: 10,
            textBrushColor: "#000000",
          },
          type: "PageNumber",
        },
        {
          type: "Text",
          value: DateExport,
          position: { x: 900, y: 0 },
          style: { font: { size: "10" } },
        },
      ],
      fromBottom: 0,
      height: 100,
    },
  };
};


/// Add By POOM : 2024-05-29
/// เป็น Exel Header
/// เป็น เป็นค่า Setting รูปการ Export file Excel ใช้ในหน้า customer View ในส่วนของ Task
export const excelExport_CV_Task_GropBy = (
  FileName,
  ReportName,
  Customer,
  ProjectName,
  GroupBy,
  Task,
  Staff,
  Date,
  Status,
  colspan,
  DateExport
) => {
  
  if (Date === "") {
    Date = ConfigETC.ddl_All;
  }

  if (ProjectName === "") {
    ProjectName = ConfigETC.ddl_All;
  }

  if (Task === "") {
    Task = ConfigETC.ddl_All;
  }

  if (Staff === "") {
    Staff = ConfigETC.ddl_All;
  }

  if (Status === "") {
    Status = ConfigETC.ddl_All;
  }

  let colSpan = colspan;
  return {
    fileName: FileName,
    header: {
      headerRows: 8,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: ReportName,
              style: {
                fontColor: "#000000",
                fontSize: 20,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: Customer,
              style: {
                fontColor: "#000000",
                fontSize: 15,
                hAlign: "Center",
                bold: true,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `View data by : ${GroupBy}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Date : ${Date}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Project : ${ProjectName}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Task : ${Task}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },

        {
          cells: [
            {
              colSpan: colSpan,
              value: `Staffs : ${Staff}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
        {
          cells: [
            {
              colSpan: colSpan,
              value: `Status : ${Status}`,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Left",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    footer: {
      footerRows: 1,
      rows: [
        {
          cells: [
            {
              colSpan: colSpan,
              value: DateExport,
              style: {
                fontColor: "#000000",
                fontSize: 10,
                hAlign: "Right",
                bold: false,
              },
            },
          ],
        },
      ],
    },
    theme: {    
      header: {
        borders: { 
          color: '#000000',
          lineStyle: 'thin',
        },
      },
      record: {
        borders: {
          color: '#000000',
          lineStyle: 'thin',
        },
      },
    },
  };
};



